'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var clear = exports.clear = {
  '&:before, &:after': {
    display: 'table',
    content: ' ',
    clear: 'both'
  }
};